/* global $ */

class Loading {
    constructor() {
        $(".js-Loading").addClass("is-Loading");
    }
}

export default Loading;